import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'

export function ProtectedRoute() {
  const initialized = useAuthStore((s) => s.initialized)
  const user = useAuthStore((s) => s.user)

  if (!initialized) {
    return (
      <div className="flex h-screen items-center justify-center text-b4l-text-muted">
        Se încarcă…
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  return <Outlet />
}
